import { getFallbackMapCount, getMapBalance } from "./balance.js";

export const COLS = 20;
export const ROWS = 12;
export const CELL = 48;
export const BOARD_WIDTH = COLS * CELL;
export const BOARD_HEIGHT = ROWS * CELL;
export const UNIT_LIMIT = 40;
export const TOTAL_MAPS = getFallbackMapCount();
export const WAVES_PER_MAP = 20;

export const SAVE_SCHEMA_VERSION = 2;
export const LOCAL_SAVE_KEY = "stellarSiegeSaveV2";
export const LEGACY_SAVE_KEY = "stellarSiegeSaveV1";
export const SETTINGS_KEY = "stellarSiegeSettingsV2";

export const startingGold = (mapContext) => getMapBalance(mapContext).startingGold;
